exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 768px) {\n  .search-preview-header {\n    display: grid !important;\n    margin-bottom: 15px !important;\n    top: -10px;\n    position: relative; }\n  .header-buttons {\n    margin-top: 10px !important; }\n    .header-buttons div div button {\n      display: block !important;\n      height: 65px !important;\n      width: 157px !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/PTHeader/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/PTHeader/index.css
// module chunks = 504